import React from 'react';
import { Link } from '@/ui/common/Link';
import styles from '../index.module.scss';

type Props = {
  /** リンクの子要素 */
  children: React.ReactNode;
  /** リンク先のURL（内部リンクの場合はパス、外部リンクの場合は完全なURL） */
  href: string;
};

/**
 * パンくずリスト用のリンクコンポーネント
 *
 * 内部リンクと外部リンクの両方をサポートします。
 * 内部リンク（`/`で始まるパス）の場合はReact RouterのLinkコンポーネントを使用し、
 * 外部リンク（`/`で始まらないURL）の場合は通常のaタグを使用します。
 *
 * @example
 * ```tsx
 * // 内部リンク
 * <BreadcrumbLink href="/dashboard">ダッシュボード</BreadcrumbLink>
 *
 * // 外部リンク
 * <BreadcrumbLink href="https://example.com">外部サイト</BreadcrumbLink>
 * ```
 */
export const BreadcrumbLink: React.FC<Props> = ({ children, href }) => {
  return (
    <Link
      className={styles.link}
      to={href}
      // `/`で始まらない場合は外部リンクとして扱う
      isExternal={!href.startsWith('/')}
    >
      {children}
    </Link>
  );
};
